import { render, staticRenderFns } from "./private-genre-banner.vue?vue&type=template&id=c5a9bc50&scoped=true&"
import script from "./private-genre-banner.vue?vue&type=script&lang=js&"
export * from "./private-genre-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a9bc50",
  null
  
)

export default component.exports